module.exports = __webpack_public_path__ + "a768e7de/img/settings-icon.121d9519.svg";